import { testimonials } from "@/mocks/guawa";

const stats = [
  { value: "2.4亿+", label: "全网累计围观", icon: "ri-eye-fill", tone: "text-primary-500" },
  { value: "12.6万", label: "篇瓜友热议", icon: "ri-chat-3-fill", tone: "text-accent-500" },
  { value: "386", label: "个活跃话题分类", icon: "ri-price-tag-3-fill", tone: "text-primary-600" },
  { value: "96%", label: "讨论氛围好评率", icon: "ri-heart-fill", tone: "text-accent-600" },
];

export default function BrandBand() {
  return (
    <section className="bg-cream-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-14">
        {/* 数据带 */}
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="flex items-center gap-3 rounded-2xl border border-cream-200 bg-white p-5"
            >
              <span className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-cream-100 text-2xl ${s.tone}`}>
                <i className={s.icon}></i>
              </span>
              <div>
                <p className="text-2xl font-extrabold tracking-tight text-ink-900">{s.value}</p>
                <p className="mt-0.5 text-xs text-ink-500">{s.label}</p>
              </div>
            </div>
          ))}
        </div>

        {/* 口碑 */}
        <div className="mt-12 flex flex-col items-center text-center">
          <span className="text-xs font-semibold uppercase tracking-widest text-primary-600">瓜友口碑</span>
          <h2 className="mt-1 text-2xl font-extrabold tracking-tight text-ink-900 md:text-3xl">
            听过来人怎么夸今日曝瓜
          </h2>
          <div className="mt-3 flex items-center gap-1 text-accent-500">
            {Array.from({ length: 5 }).map((_, i) => (
              <i key={i} className="ri-star-fill"></i>
            ))}
            <span className="ml-2 text-sm font-semibold text-ink-700">4.9 瓜友评分</span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((t) => (
            <figure
              key={t.id}
              className="flex flex-col rounded-2xl border border-cream-200 bg-white p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
              <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-ink-700">“{t.text}”</blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-cream-100 pt-3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-lg">
                  {t.avatar}
                </span>
                <div>
                  <p className="text-sm font-bold text-ink-800">{t.nick}</p>
                  <p className="text-xs text-ink-400">{t.role}</p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}